<template>
    <div class="row">
        <div class="col-12">
            <div class="wrapper-input" v-bind:class="{ error: errors.contact_nome }">
                <input
                type="text"
                v-model="theModel.name"
                :placeholder="$t('step3.contact.nome') + '*'"
                @input="(e)=>this.$emit('onClearError', {key:'contact_nome', value: !!e.target.value})"
                />
            </div>
        </div>
        <div class="col-12">
            <div class="wrapper-input" v-bind:class="{ error: errors.contact_cognome }">
                <input
                type="text"
                v-model="theModel.surname"
                :placeholder="$t('step3.contact.cognome') + '*'"
                @input="(e)=>this.$emit('onClearError', {key:'contact_cognome', value: !!e.target.value})"
                />
            </div>
        </div>
        <div class="col-12">
            <div class="wrapper-input" v-bind:class="{ error: errors.contact_azienda }">
                <input
                type="text"
                v-model="theModel.company"
                :placeholder="$t('step3.contact.azienda')+' '+(companyRequired ? '*':'')"
                @input="(e)=>this.$emit('onClearError', {key:'contact_azienda', value: !!e.target.value})"
                />
            </div>
        </div>
        <div class="col-12">
            <div class="wrapper-input" v-bind:class="{ error: errors.contact_email }">
                <input
                type="email"
                v-model="theModel.email"
                :placeholder="$t('step3.contact.email') + '*'"
                @input="(e)=>this.$emit('onClearError', {key:'contact_email', value: !!e.target.value})"
                />
            </div>
        </div>
        <div class="col-12">
            <div class="wrapper-input phone-input" v-bind:class="{ error: errors.contact_tel }">
                <div class="phone-prefix-select">
                    <select v-model="theModel.telephonePrefix" :aria-label="$t('general.prefisso_telefonico')">
                        <option v-for="prefix in phonePrefixes" :key="prefix" :value="prefix">{{ prefix }}</option>
                    </select>
                </div>
                <input
                type="tel"
                v-model="theModel.telephone"
                :placeholder="$t('step3.contact.telefono') + '*'"
                @input="(e)=>this.$emit('onClearError', {key:'contact_tel', value: !!e.target.value})"
                />
            </div>
        </div>
        <div class="col-12">
            <div class="wrapper-input" v-bind:class="{ error: errors.contact_indirizzo }">
                <input
                type="text"
                v-model="theModel.address"
                :placeholder="$t('step3.contact.indirizzo') + '*'"
                @input="(e)=>this.$emit('onClearError', {key:'contact_indirizzo', value: !!e.target.value})"
                />
            </div>
        </div>
        <div class="d-flex col-12">
            <div class="col-6 pe-2">
                <div class="wrapper-input" v-bind:class="{ error: errors.contact_cap }">
                    <input
                    type="text"
                    v-model="theModel.cap"
                    :placeholder="$t('step3.contact.cap') + '*'"
                    @input="(e)=>this.$emit('onClearError', {key:'contact_cap', value: !!e.target.value})"
                    />
                </div>
            </div>
            <div class="col-6 ps-2">
                <div v-if="theModel.country=='Italia'" class="wrapper-input select" v-bind:class="{ error: errors.contact_provincia }">
                    <select required v-model="theModel.province" @change="(e)=>this.$emit('onClearError', {key:'contact_provincia', value: !!e.target.value})">
                        <option disabled selected value>{{$t('step3.contact.provincia')}} <span class="ic-require">*</span></option>
                        <option
                            v-for="item in listProvince"
                            :key="item.value"
                            v-bind:value="item.value"
                            v-text="item.label"
                        ></option>
                    </select>
                </div>
                <div v-else class="wrapper-input" v-bind:class="{ error: errors.contact_provincia }">
                    <input
                        type="text"
                        v-model="theModel.province"
                        :placeholder="$t('step3.contact.provincia') + '*'"
                        @input="(e)=>this.$emit('onClearError', {key:'contact_provincia', value: !!e.target.value})"
                    />
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="wrapper-input select" v-bind:class="{ error: errors.contact_paese }">
                <select required v-model="theModel.country" @change="onCountryChange">
                    <option disabled selected value>{{$t('step3.contact.paese')}} <span class="ic-require">*</span></option>
                    <option
                        v-for="item in listCountries"
                        :key="item.value"
                        v-bind:value="item.value"
                        v-text="capitalize(item.label)"
                    ></option>
                </select>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent, computed } from 'vue';
import listProvince from "./../consts/listProvince"
import listCountries from "./../consts/listCountries"
import phonePrefixes from "./../consts/listPhonePrefixes"

export default defineComponent({
        name:"ContactForm",
        emits: ['update:modelValue', 'onClearError'],
        data(){
            return { listProvince, listCountries, phonePrefixes }
        },
        methods:{
            capitalize(str){
                return str.toLowerCase().replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());
            },
            onCountryChange(event){
                const selectedCountry = this.listCountries.find(item => item.value === event.target.value)
                this.theModel.hs_country_region_code = selectedCountry?.hs_country_region_code
                this.theModel.province = ""
                this.$emit('onClearError', {key:'contact_paese', value: !!event.target.value})
            }
        },
        props: {
            modelValue: {
                type: Object,
                default: () => ({}),
            },
            companyRequired:{
                type: Boolean,
                default: false
            },
            errors: {
                type: Object,
                default: () => ({}),
            }
        },
        setup(props, { emit }) {
            const theModel = computed({  // Use computed to wrap the object
                get: () => props.modelValue,
                set: (value) => emit('update:modelValue', value),
            });
            return { theModel };
        }
})
</script>
